const breadCrumb = "Lotação de Servidores - Regime Complementar";

const routes = [
  {
    path: "/solicitacao-de-pedido-de-acrescimo",
    name: "solicitacao-de-pedido-de-acrescimo",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegimeComplementar/SolicitacaoDePedidoDeAcrescimo/SolicitacaoDePedidoDeAcrescimoHome.vue"
      ),
  },
  {
    path: "/solicitacao-de-pedido-de-acrescimo/novo",
    name: "solicitacao-de-pedido-de-acrescimo-novo",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegimeComplementar/SolicitacaoDePedidoDeAcrescimo/SolicitacaoDePedidoDeAcrescimoCad.vue"
      ),
  },
  {
    path: "/solicitacao-de-pedido-de-acrescimo/editar/:id",
    name: "solicitacao-de-pedido-de-acrescimo-editar",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegimeComplementar/SolicitacaoDePedidoDeAcrescimo/SolicitacaoDePedidoDeAcrescimoEdit.vue"
      ),
  },
  {
    path: "/solicitacao-de-pedido-de-acrescimo/visualizar/:id",
    name: "solicitacao-de-pedido-de-acrescimo-visualizar",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegimeComplementar/SolicitacaoDePedidoDeAcrescimo/SolicitacaoDePedidoDeAcrescimoShow.vue"
      ),
  },
  {
    path: "/solicitacao-de-pedido-de-acrescimo/cessar/:id",
    name: "solicitacao-de-pedido-de-acrescimo-cessar",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PedidosDeAcrescimo/CessarEfeitoPortaria/CessarEfeitoPortaria.vue"
      ),
  },
  {
    path: "/solicitacao-de-pedido-de-acrescimo/remanejar/:id",
    name: "solicitacao-de-pedido-de-acrescimo-remanejar",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegimeComplementar/SolicitacaoDePedidoDeAcrescimo/SolicitacaoDePedidoDeAcrescimoRemanejar.vue"
      ),
  },
];

export default routes;
